var map = {
	"./logo_amazon.png": "6a95",
	"./logo_breakfast.png": "3175",
	"./logo_dessert.png": "5942",
	"./logo_facebook.png": "5bd0",
	"./logo_instagram.png": "1847",
	"./logo_main.png": "0151",
	"./logo_mobile_apps.png": "d92d",
	"./logo_ooh.png": "3a43",
	"./logo_template.png": "4742",
	"./logo_template.xcf": "3373",
	"./logo_tv.png": "3ae0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5d1d";